var AppDevPlanStatusService = /** @class */ (function () {
    function AppDevPlanStatusService(api) {
        var _this = this;
        this.getAppDevPlanStatus = function (app_id) {
            return _this.API.get("/apps/".concat(app_id, "/organization/status"));
        };
        this.API = api;
    }
    return AppDevPlanStatusService;
}());
export { AppDevPlanStatusService };
